var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjectSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow",
    viewBox: "0 0 12.002 14.828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group_3594",
    "data-name": "group 3594",
    transform: "translate(-548.998 -1011.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_4754",
    "data-name": "path 4754",
    d: "M-18926.314-18570.389l6,6.137-6,5.863",
    transform: "translate(19480.314 19583.383)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_4755",
    "data-name": "path 4755",
    d: "M-18930.949-18564.109h9",
    transform: "translate(19480.947 19583.104)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-circle",
    viewBox: "0 0 52 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    "data-name": "group 3585",
    transform: "translate(-1318 -1157)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle_39",
    "data-name": "circle 39",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(1318 1157)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "group_3580",
    "data-name": "group 3580",
    transform: "translate(788 163.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_4754",
    "data-name": "path 4754",
    d: "M-18926.312-18570.385l7,7.156-7,6.844",
    transform: "translate(19481.313 19583.379)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_4755",
    "data-name": "path 4755",
    d: "M-18930.947-18564.109h10",
    transform: "translate(19480.947 19584.104)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-circle-white",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group_3626",
    "data-name": "group 3626",
    transform: "translate(-1638 278) rotate(-90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle__1",
    "data-name": "circle_ 1",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(254 1638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "group_3478",
    "data-name": "group 3478",
    transform: "translate(262.25 1647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_4717",
    "data-name": "path 4717",
    d: "M-17673.131-18040.5l3.748,4.5,3.752-4.5",
    transform: "translate(17673.131 18042.746)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path_4718",
    "data-name": "path 4718",
    d: "M-17669.133-18044v6.75",
    transform: "translate(17672.883 18044.002)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "btn-cv",
    viewBox: "0 0 160 160"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "polygon_4",
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4e0000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#polygon_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon_4-2",
    "data-name": "polygon 4",
    d: "M57.792,4.8a13,13,0,0,1,14.416,0l5.6,3.732a13,13,0,0,0,7.363,2.18l6.721-.08a13,13,0,0,1,12.063,7.784l2.78,6.347a13,13,0,0,0,4.959,5.771l5.842,3.695a13,13,0,0,1,5.9,12.969l-1.08,7a13,13,0,0,0,1.066,7.476l2.991,6.415A13,13,0,0,1,124.4,82.164l-4.629,5.27a13,13,0,0,0-3.124,6.9l-.909,6.968a13,13,0,0,1-9.343,10.825l-6.545,1.857a13,13,0,0,0-6.419,4.16l-4.377,5.227a13,13,0,0,1-13.812,4.072l-6.4-1.98a13,13,0,0,0-7.691,0l-6.395,1.98a13,13,0,0,1-13.812-4.072l-4.377-5.227a13,13,0,0,0-6.419-4.16l-6.545-1.857A13,13,0,0,1,14.264,101.3l-.909-6.968a13,13,0,0,0-3.124-6.9L5.6,82.164A13,13,0,0,1,3.588,68.091l2.991-6.415A13,13,0,0,0,7.644,54.2l-1.08-7a13,13,0,0,1,5.9-12.969L18.3,30.536a13,13,0,0,0,4.959-5.771l2.78-6.347a13,13,0,0,1,12.063-7.784l6.721.08a13,13,0,0,0,7.363-2.18Z",
    transform: "translate(15 15)"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-rank",
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon_18",
    "data-name": "polygon 18",
    d: "M22.661,1.685a4,4,0,0,1,4.677,0l4.1,2.956a4,4,0,0,0,2.01.741l5.03.414a4,4,0,0,1,3.546,2.99l1.295,5.034a4,4,0,0,0,1.042,1.828l3.661,3.671a4,4,0,0,1,.792,4.517L46.6,28.581a4,4,0,0,0-.359,2.06l.483,5.219a4,4,0,0,1-2.294,3.994L39.8,42.012a4,4,0,0,0-1.619,1.376L35.3,47.625a4,4,0,0,1-4.382,1.6l-4.841-1.351a4,4,0,0,0-2.15,0l-4.841,1.351a4,4,0,0,1-4.382-1.6L11.82,43.388A4,4,0,0,0,10.2,42.012L5.569,39.855a4,4,0,0,1-2.294-3.994l.483-5.219a4,4,0,0,0-.359-2.06L1.184,23.837a4,4,0,0,1,.792-4.517l3.661-3.671a4,4,0,0,0,1.042-1.828L7.973,8.787A4,4,0,0,1,11.519,5.8l5.03-.414a4,4,0,0,0,2.01-.741Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-access",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "explore_FILL1_wght400_GRAD0_opsz24",
    d: "M96-862.4a1.548,1.548,0,0,1-1.14-.46A1.548,1.548,0,0,1,94.4-864a1.548,1.548,0,0,1,.46-1.14A1.548,1.548,0,0,1,96-865.6a1.548,1.548,0,0,1,1.14.46A1.548,1.548,0,0,1,97.6-864a1.548,1.548,0,0,1-.46,1.14A1.548,1.548,0,0,1,96-862.4ZM96-848a15.58,15.58,0,0,1-6.24-1.26,16.157,16.157,0,0,1-5.08-3.42,16.157,16.157,0,0,1-3.42-5.08A15.58,15.58,0,0,1,80-864a15.58,15.58,0,0,1,1.26-6.24,16.158,16.158,0,0,1,3.42-5.08,16.158,16.158,0,0,1,5.08-3.42A15.581,15.581,0,0,1,96-880a15.581,15.581,0,0,1,6.24,1.26,16.158,16.158,0,0,1,5.08,3.42,16.158,16.158,0,0,1,3.42,5.08A15.58,15.58,0,0,1,112-864a15.58,15.58,0,0,1-1.26,6.24,16.157,16.157,0,0,1-3.42,5.08,16.157,16.157,0,0,1-5.08,3.42A15.58,15.58,0,0,1,96-848Zm0-3.2a12.354,12.354,0,0,0,9.08-3.72A12.354,12.354,0,0,0,108.8-864a12.354,12.354,0,0,0-3.72-9.08A12.353,12.353,0,0,0,96-876.8a12.353,12.353,0,0,0-9.08,3.72A12.354,12.354,0,0,0,83.2-864a12.354,12.354,0,0,0,3.72,9.08A12.354,12.354,0,0,0,96-851.2Zm0,0a12.354,12.354,0,0,1-9.08-3.72A12.354,12.354,0,0,1,83.2-864a12.354,12.354,0,0,1,3.72-9.08A12.353,12.353,0,0,1,96-876.8a12.353,12.353,0,0,1,9.08,3.72A12.354,12.354,0,0,1,108.8-864a12.354,12.354,0,0,1-3.72,9.08A12.354,12.354,0,0,1,96-851.2Zm2.68-9.36a1.688,1.688,0,0,0,.44-.32,1.687,1.687,0,0,0,.32-.44l4.68-10a.554.554,0,0,0-.1-.7.555.555,0,0,0-.7-.1l-10,4.68a1.689,1.689,0,0,0-.44.32,1.689,1.689,0,0,0-.32.44l-4.68,10a.555.555,0,0,0,.1.7.554.554,0,0,0,.7.1Z",
    transform: "translate(-80 880)"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-faq",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "help_FILL1_wght400_GRAD0_opsz24",
    d: "M95.92-854.4a1.931,1.931,0,0,0,1.42-.58,1.931,1.931,0,0,0,.58-1.42,1.931,1.931,0,0,0-.58-1.42,1.931,1.931,0,0,0-1.42-.58,1.931,1.931,0,0,0-1.42.58,1.931,1.931,0,0,0-.58,1.42,1.931,1.931,0,0,0,.58,1.42A1.931,1.931,0,0,0,95.92-854.4ZM96-848a15.58,15.58,0,0,1-6.24-1.26,16.157,16.157,0,0,1-5.08-3.42,16.157,16.157,0,0,1-3.42-5.08A15.58,15.58,0,0,1,80-864a15.58,15.58,0,0,1,1.26-6.24,16.158,16.158,0,0,1,3.42-5.08,16.158,16.158,0,0,1,5.08-3.42A15.581,15.581,0,0,1,96-880a15.581,15.581,0,0,1,6.24,1.26,16.158,16.158,0,0,1,5.08,3.42,16.158,16.158,0,0,1,3.42,5.08A15.58,15.58,0,0,1,112-864a15.58,15.58,0,0,1-1.26,6.24,16.157,16.157,0,0,1-3.42,5.08,16.157,16.157,0,0,1-5.08,3.42A15.58,15.58,0,0,1,96-848Zm.16-22.88a2.576,2.576,0,0,1,1.74.64,2.029,2.029,0,0,1,.74,1.6,2.439,2.439,0,0,1-.54,1.56,10.009,10.009,0,0,1-1.22,1.28,10.62,10.62,0,0,0-1.62,1.76,3.576,3.576,0,0,0-.7,2.16,1.217,1.217,0,0,0,.42.94,1.415,1.415,0,0,0,.98.38,1.425,1.425,0,0,0,1.02-.4,1.844,1.844,0,0,0,.54-1,3.211,3.211,0,0,1,.72-1.5,15.249,15.249,0,0,1,1.2-1.26,10.259,10.259,0,0,0,1.58-1.92,4.24,4.24,0,0,0,.66-2.32,4.057,4.057,0,0,0-1.66-3.34,6.081,6.081,0,0,0-3.86-1.3,6.813,6.813,0,0,0-2.9.64,4.473,4.473,0,0,0-2.1,1.96,1.443,1.443,0,0,0-.18,1.02,1.182,1.182,0,0,0,.54.82,1.628,1.628,0,0,0,1.16.2,1.593,1.593,0,0,0,1-.68,2.933,2.933,0,0,1,1.1-.92A3.126,3.126,0,0,1,96.16-870.88Z",
    transform: "translate(-80 880)"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-facebook",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "polygon_3396",
    "data-name": "polygon 3396",
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "group_3735-2",
    "data-name": "group 3735",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path_4760",
    "data-name": "path 4760",
    d: "M24,12A12,12,0,1,0,9.1,23.647v-7.98H6.627V12H9.1V10.42c0-4.084,1.848-5.978,5.858-5.978a13.231,13.231,0,0,1,2.609.3V8.065c-.283-.03-.775-.045-1.386-.045-1.968,0-2.728.745-2.728,2.683V12h3.92L16.7,15.667H13.454v8.245A12,12,0,0,0,24,12"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-x",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group_3564",
    "data-name": "group 3564",
    transform: "translate(-1219 -5878)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle_16",
    "data-name": "circle 16",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1219 5878)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo",
    d: "M10,7.336,16.255,0H14.773L9.341,6.37,5,0H0L6.56,9.632,0,17.325H1.482L7.218,10.6,11.8,17.325h5L10,7.336ZM7.97,9.717,7.3,8.758,2.016,1.126H4.293L8.561,7.285l.665.959,5.548,8.006H12.5L7.97,9.717Z",
    transform: "translate(1222.599 5881.337)"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-instagram",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group_3563",
    "data-name": "group 3563",
    transform: "translate(-1219 -5878)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle _16",
    "data-name": "circle  16",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1219 5878)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Instagram_Glyph_White",
    d: "M8.042,2.569a6.9,6.9,0,0,0-2.3.444A4.839,4.839,0,0,0,2.985,5.785a6.952,6.952,0,0,0-.435,2.3C2.505,9.09,2.5,9.413,2.5,11.983s.016,2.891.065,3.9a6.916,6.916,0,0,0,.444,2.295A4.836,4.836,0,0,0,5.782,20.94a6.946,6.946,0,0,0,2.3.435c1.007.044,1.331.054,3.9.049s2.892-.016,3.9-.064a6.922,6.922,0,0,0,2.294-.444,4.835,4.835,0,0,0,2.761-2.773,6.921,6.921,0,0,0,.435-2.3c.044-1.01.054-1.332.05-3.9s-.016-2.891-.064-3.9a6.91,6.91,0,0,0-.444-2.3,4.645,4.645,0,0,0-1.094-1.674A4.617,4.617,0,0,0,18.14,2.989a6.924,6.924,0,0,0-2.3-.435c-1.007-.044-1.331-.055-3.9-.05s-2.891.016-3.9.065m.111,17.1A5.251,5.251,0,0,1,6.4,19.352a2.946,2.946,0,0,1-1.09-.706,2.914,2.914,0,0,1-.71-1.087A5.24,5.24,0,0,1,4.267,15.8c-.047-1-.057-1.3-.062-3.822s0-2.825.048-3.822A5.236,5.236,0,0,1,4.575,6.4,3.132,3.132,0,0,1,6.367,4.6a5.239,5.239,0,0,1,1.756-.329c1-.047,1.3-.057,3.822-.062s2.825,0,3.824.048a5.232,5.232,0,0,1,1.757.322,3.132,3.132,0,0,1,1.8,1.793,5.212,5.212,0,0,1,.329,1.755c.047,1,.058,1.3.063,3.822s0,2.825-.048,3.822a5.257,5.257,0,0,1-.322,1.758,3.134,3.134,0,0,1-1.793,1.8,5.241,5.241,0,0,1-1.755.329c-1,.047-1.3.057-3.823.062s-2.825,0-3.822-.048M15.866,6.908A1.135,1.135,0,1,0,17,5.77a1.135,1.135,0,0,0-1.133,1.137M7.1,11.974a4.858,4.858,0,1,0,4.849-4.868A4.858,4.858,0,0,0,7.1,11.974m1.7,0a3.154,3.154,0,1,1,3.16,3.148,3.154,3.154,0,0,1-3.16-3.148",
    transform: "translate(1219.039 5878.035)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectSet);
export default __webpack_public_path__ + "static/media/objectSet.2a858ec48444a0a8d79e15aefe3d1b65.svg";
export { ForwardRef as ReactComponent };